<div class="px-2" style="margin-top: 55px; height: 100%;">
  <app-content-heading [icon]='iconList.faCloud' class="pt-2" [title]="pageTitle"
    [registerPage]="true"></app-content-heading>
  <app-wizard-layout [wizardTabs]='wizardTabList' class="h-100" (currentIndexEmitter)="onWizardTabChange($event)"
    [currentIndex]="currentTabIndex">

    <div class="h-100 container-fuild" sample>

      <div class="d-flex flex-column flex-md-row h-100  w-full peering-parent" *ngIf="wizardTabList[currentTabIndex] === PeeringTab.Configuration">
        <div class="col col-md-3 p-0">
          <app-add-peer-to-network [currentEnvironment]="currentEnvironment" [peeringForm]="peeringForm"
            [environments]="environments" (environmentSelected)="handleEnvironmentSelected($event)"
            (addPeerSubmitted)="handlePeerSubmission($event)"></app-add-peer-to-network>
        </div>
        <div class="col col-md-9 p-0">
          <app-networks-to-peer [selectedEnvironments]="selectedEnvironments" (deleteEnv)="confirmDeleteEnvironment($event)"></app-networks-to-peer>
        </div>
        <div class='footer w-100 d-block' style="padding-left: 1.4vw;">
          <div class="d-flex flex-row align-items-center h-100">
            <button class="btn btn-sm btn-primary btn-nc me-3" [disabled]="selectedEnvironments.length === 0"
              [style.cursor]="this.environments.length === 0 ? 'default' : 'pointer'"
              (click)="onWizardTabChange(1)">Next</button>
            <button class="btn btn-sm btn-outline-primary btn-nc" (click)="confirmCancelPeering()">Cancel</button>
          </div>
        </div>
      </div>

      <div class="h-100 w-100" *ngIf="wizardTabList[currentTabIndex] === PeeringTab.Review">
        <app-review-selected-networks [selectedEnvironments]="selectedEnvironments"></app-review-selected-networks>
      </div>

    </div>

  </app-wizard-layout>
</div>

<div class='footer mx-3 pb-3' dir="ltr" fxLayoutGap="25px"
  *ngIf="wizardTabList[currentTabIndex] === PeeringTab.Configuration">
  <button class="btn btn-sm btn-primary btn-nc me-3 px-3" [disabled]="selectedEnvironments.length === 0"
    [style.cursor]="this.environments.length === 0 ? 'default' : 'pointer'" (click)="onWizardTabChange(1)">Next</button>
  <button class="btn btn-sm btn-outline-primary btn-nc" (click)="confirmCancelPeering()">Cancel</button>
</div>

<div class='footer mx-3 pb-3' dir="ltr" fxLayoutGap="25px" *ngIf="wizardTabList[currentTabIndex] === PeeringTab.Review">

  <div class="d-flex flex-row">
    <button class="btn btn-sm btn-primary btn-nc me-2" (click)="confirmPeeringCreation()">Create
      Peering</button>
    <button class="btn btn-sm btn-outline-primary btn-nc me-2" (click)="onWizardTabChange(0)">Previous</button>
    <button class="btn btn-sm btn-outline-primary btn-nc" (click)="confirmCancelPeering()">Cancel</button>
  </div>

</div>